import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import NavBar from "hrreact/components/navBar";
import Container from "./components/Container";
import TrackingBox from "./boxes/trackingBox";
import ContactBox from "./boxes/contactBox";
import MarketingBox from "./boxes/marketingBox";

function DemoTrackingPage() {
  //------------------------------------------------------------------------------------------------
  // STATE
  //------------------------------------------------------------------------------------------------

  // string representing carrier of package being displayed
  const [carrier, setCarrier] = useState("");
  // tracking content to display
  const [trackingInfo, setTrackingInfo] = useState({
    tracking: "",
    status: "",
    departure: "",
    estimated_arrival: "",
    arrival: "",
  });
  //----------

  //------------------------------------------------------------------------------------------------
  // LIFECYCLE METHODS
  //------------------------------------------------------------------------------------------------
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    const carrierParam = searchParams.get("carrier").toLowerCase();
    const trackingParam = searchParams.get("tracking");
    const statusParam = searchParams.get("status");
    const departureParam = searchParams.get("departure");
    const estimatedArrivalParam = searchParams.get("estimated-arrival");
    const arrivalParam = searchParams.get("arrival");

    setCarrier(carrierParam);
    setTrackingInfo({
      tracking: trackingParam,
      status: statusParam,
      departure: departureParam,
      estimated_arrival: estimatedArrivalParam,
      arrival: arrivalParam,
    });
  }, []);

  //------------------------------------------------------------------------------------------------
  // RENDERING
  //------------------------------------------------------------------------------------------------
  function renderNavBar() {
    return <NavBar homeURL={STYLES.home_url} />;
  }

  const navbar = renderNavBar();

  return (
    STYLES && (
      <Container
        header={navbar}
        boxStyle="container-inner"
        hidePoweredByHR={STYLES.is_white_label}
      >
        <div className="branded-tracking-page" style={{ minHeight: "100%" }}>
          <div className="branded-tracking-content">
            {/* The first column contains the tracking information and (if present) the contact link */}
            <div className="branded-tracking-content-column1">
              <TrackingBox
                trackingInfo={trackingInfo}
                carrier={carrier}
                tracking={trackingInfo.tracking}
                returnMode={false}
              />

              {(STYLES || {}).contact_url && (
                <ContactBox contactURL={STYLES.contact_url} />
              )}
            </div>

            {/* The second column contains the marketing image and link */}
            {/* marketingURL is optional to render the marketing box */}
            {(STYLES || {}).marketing_image_url && (
              <MarketingBox
                marketingURL={STYLES.marketing_url}
                marketingImageURL={STYLES.marketing_image_url}
              />
            )}
          </div>
        </div>
      </Container>
    )
  );
}

export default withRouter(DemoTrackingPage);
